export const toDetailedSpeakers = transcript => transcript.participants.map(p => ({
  name: p.name,
  email: null,
  mappedSpeakerTrackId: p.speakerTrackId,
  talkTimePercentage: p.talkTimePercentage,
  callParticipantType: 'CONTACT',
  utterances: transcript.utterances.filter(u => u.speakerName === p.name).map(u => ({
    speakerTrackId: p.speakerTrackId,
    utterance: u.text,
    startTimeSeconds: u.startTimeSeconds,
    endTimeSeconds: u.endTimeSeconds
  }))
}));
export const toTranscriptUtterances = transcript => transcript.utterances.map(u => {
  var _transcript$participa, _transcript$participa2;
  return {
    id: u.id,
    speakerTrackId: (_transcript$participa = (_transcript$participa2 = transcript.participants.find(p => p.name === u.speakerName)) === null || _transcript$participa2 === void 0 ? void 0 : _transcript$participa2.speakerTrackId) !== null && _transcript$participa !== void 0 ? _transcript$participa : -1,
    startTimeSeconds: u.startTimeSeconds,
    endTimeSeconds: u.endTimeSeconds,
    utterance: u.text,
    callTopicTags: []
  };
});
export const toTimelineUtterances = transcript => transcript.utterances.map(u => ({
  utterance: u.text,
  startTimeSeconds: u.startTimeSeconds,
  endTimeSeconds: u.endTimeSeconds,
  callTopics: []
}));
export const toTranscriptParticipants = transcript => transcript.participants.map(p => ({
  participantId: String(p.speakerTrackId),
  participantEmail: null,
  participantName: p.name,
  participantType: 'CONTACT',
  associatedObjectId: null,
  mappedCategory: 'USER_DEFINED',
  mappedSpeakerTrackId: p.speakerTrackId
}));